export function startParkingConversation(conversationSid) {
  return {
    type: 'START_ParkingConversation',
    conversationSid
  };
}

export function clearParkingConversation(conversationSid) {
  return {
    type: 'CLEAR_ParkingConversation',
    conversationSid
  };
}